type Ok<T> = { ok: true; value: T };
type Err<E> = { ok: false; error: E };

export type Result<T, E> = Ok<T> | Err<E>;

export const isOk = <T, E>(result: Result<T, E>): result is Ok<T> => result.ok;
export const isErr = <T, E>(result: Result<T, E>): result is Err<E> =>
  !result.ok;

export const ok = <T, E>(value: T): Result<T, E> => ({ ok: true, value });
export const err = <T, E>(error: E): Result<T, E> => ({ ok: false, error });
